import * as ReactDOM from 'react-dom/client';
import { IPublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';

import './styles/styles.scss';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { getAppSettings } from './services';
import { createMsalInstance } from './features';
import { IAppSettings } from './model';
import { Provider } from 'react-redux';
import { store } from './store';

async function bootstrap() {
  const config = await getAppSettings();
  const instance = await createMsalInstance(config);

  render(config, instance);
}

function render(config: IAppSettings, instance: IPublicClientApplication) {
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

  root.render(
    <Provider store={store}>
      <MsalProvider instance={instance}>
        <App settings={config} />
      </MsalProvider>
    </Provider>,
  );

  reportWebVitals();
}

bootstrap().catch((error) => console.error(error));
